<template>
  <div class ="modal-card" style="width: 800px">
   
    <header class="modal-card-head">Neuer Eintrag</header>

    <section class="modal-card-body">
      <b-field grouped>
        <b-field label="Name">
          <b-input v-model="name"></b-input>
        </b-field>

        <b-field label="Hervorheben">
          <b-checkbox v-model="featured"><span v-if="featured === true">Ja</span><span v-else>Nein</span></b-checkbox>
        </b-field>


        <b-field label="Titel">
          <b-input v-model="title"></b-input>
        </b-field>
      </b-field>
      <b-field grouped>
        <b-field label="Tags">
          <b-select multiple native-size="6" v-model="tags">
            <option v-for="tag in tag_collection" v-bind:value="tag" v-bind:key="tag">{{tag}}</option>
          </b-select>
        </b-field>

        <b-field label="Beschreibung">
          <b-input v-model="description" maxlength="10000" type="textarea"></b-input>
        </b-field>
        
        <b-field label="Adresse">
          <b-input v-model="address" maxlength="1000" type="textarea"></b-input>
        </b-field>
      </b-field>
      <b-field grouped>
        <b-field label="Telefon">
          <b-input v-model="telephone"></b-input>
        </b-field>
        
        <b-field label="E-Mail">
          <b-input v-model="email" type="email"></b-input>
        </b-field>
      
        <b-field label="Website">
          <b-input v-model="url" type="url"></b-input>
        </b-field>
      </b-field>
      <b-field grouped>
        <b-field label="Kosten">
          <b-input v-model="cost" maxlength="1000" type="textarea"></b-input>
        </b-field>

        <b-field label="Anfahrt">
          <b-input v-model="approach" maxlength="1000" type="textarea"></b-input>
        </b-field>

        <b-field label="Öffnungszeiten">
          <b-input v-model="hours" maxlength="1000" type="textarea"></b-input>
        </b-field>
      </b-field>
      <b-field grouped>
        <section>
          <b-field label="Bild">
            <b-upload v-model="image" drag-drop>
              <section class="section">
                <div class="content has-text-centered">
                    <p>Bild hier hinzufügen</p>
                </div>
              </section>
            </b-upload>
          </b-field>

          <div>
            <span v-if="image" class="is-primary" >
              {{image.name}}
              <button class="delete is-small"
                  type="button"
                  @click="deleteImage()">
              </button>
            </span>
          </div>
        </section>

        <section>
          <b-field label="Datei">
            <b-upload v-model="file" drag-drop>
              <section class="section">
                <div class="content has-text-centered">
                    <p>Datei hier hinzufügen</p>
                </div>
              </section>
            </b-upload>
          </b-field>

          <div>
            <span v-if="image" class="is-primary" >
              {{file.name}}
              <button class="delete is-small"
                  type="button"
                  @click="deleteFile()">
              </button>
            </span>
          </div>

        </section>
       
      </b-field>
      <b-field grouped>
         <b-field label="Bezirk">
          <b-input v-model="district"></b-input>
        </b-field>

        <b-field label="Position">
          <section>
            <b-input v-model="lat" placeholder="lat" style="width: 45%"></b-input>
            <b-input v-model="long" placeholder="long" style="width: 45%"></b-input>
          </section>
        </b-field>
      </b-field>
    </section>

    <footer class="modal-card-foot" style="justify-content: flex-end">
      <b-button type="is-warning" @click="clear">Verwerfen</b-button>
      <b-button type="is-success" @click="save" :disabled="name == ''">Speichern</b-button>
    </footer>

  </div>
</template>


<script>
import db from "../db"
import firebase from "firebase";

export default {
  name: "adminNew",
  data() {
    return {
      tag_collection:[],
      name:'',
      featured:false,
      title:'',
      tags: [],
      description:'',
      address:'',
      telephone:'',
      email:'',
      url:'',
      cost:'',
      approach:'',
      hours:'',
      image:null,
      file:null,
      district:'',
      lat:'',
      long:''
    }
  },
  created:function () {
      fetch("tag_collection.json")
        .then(r => r.json())
        .then(json => {this.tag_collection = json.tags})
  },
  methods: {
    async save() {
      
      // handle image
      var imageURL = 'https://firebasestorage.googleapis.com/v0/b/naturerleben-dev.appspot.com/o/posts%2Fb2bb2713-206c-4df6-b05e-185e5e814081%2Fnehh001.jpg?alt=media&token=75190834-7363-4b43-a0a1-b4f1201c231f';
      
      var storageRef = firebase.storage().ref()

      // upload image and get download url 
      if (this.image) {
        var imageRef = storageRef.child('posts/'+ this.$uuid.v4() + '/' + this.image.name)
        imageURL = await imageRef.put(this.image).then(function() {
          return imageRef.getDownloadURL().then(function(url){return url})
        })
      }

      // upload file and get download url 
      if (this.file) {
        var fileRef = storageRef.child('posts/'+ this.$uuid.v4() + '/' + this.file.name)
        var fileURL = await fileRef.put(this.file).then(function() {
          return fileRef.getDownloadURL().then(function(url){return url})
        })
      }

      const post = {'name': this.name,
                    'featured': this.featured,
                    'title': this.title,
                    'tags': this.tags,
                    'description': this.description,
                    'address': this.address,
                    'telephone': this.telephone,
                    'email': this.email,
                    'url': this.url,
                    'cost': this.cost,
                    'approach': this.approach,
                    'image': imageURL,
                    'file': fileURL,
                    'hours': this.hours,
                    'district': this.district,
                    'lat': this.lat,
                    'long': this.long}

      db.collection("posts").add(post)
        .then(() => {
            this.$buefy.snackbar.open(`Gespeichert!`)
            this.clear()
        })
        .catch(function(error) {
            console.error("Error writing document: ", error);
        });
    },
    clear() {
      this.name=''
      this.featured=''
      this.title=''
      this.tags= []
      this.description=''
      this.address=''
      this.telephone=''
      this.email=''
      this.url=''
      this.cost=''
      this.approach=''
      this.hours=''
      this.image=null
      this.district=''
      this.lat=''
      this.long=''
    },
    deleteImage() {
      this.image = null
    },
    deleteFile() {
      this.file = null
    }
  }
};
</script>

<style lang="scss" scoped>

@import '@/assets/styles/main.scss';

.field {
  max-width: 300px;
  margin-left: 20px;
}

</style>